import React from 'react';
import { Link } from 'react-router-dom';

const Settings = () => {
    return (
        <div className="app-content main-content mt-0">
            <div className="side-app">
                <div className="main-container container-fluid">
                    <div className="page-header">
                        <div>
                            <h1 className="page-title">Settings</h1>
                            <p className="text-muted">Manage your account and application settings.</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <Link to="/settings/dahab-credentials" className="text-decoration-none text-dark">
                                        <div className="d-flex align-items-center">
                                            <div className="me-3">
                                                <i className="fe fe-key fs-3 text-primary"></i>
                                            </div>
                                            <div>
                                                <h5 className="mb-0">Generate API Credentials</h5>
                                                <small className="text-muted">Create and manage your API keys for service access.</small>
                                            </div>
                                            <div className="ms-auto">
                                                <i className="fe fe-chevron-right"></i>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <Link to="/settings/whitelist-ips" className="text-decoration-none text-dark">
                                        <div className="d-flex align-items-center">
                                            <div className="me-3">
                                                <i className="fe fe-shield fs-3 text-success"></i>
                                            </div>
                                            <div>
                                                <h5 className="mb-0">Whitelist IPs</h5>
                                                <small className="text-muted">Manage IP addresses that are allowed to access the API.</small>
                                            </div>
                                            <div className="ms-auto">
                                                <i className="fe fe-chevron-right"></i>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
